import React, { useState } from "react";
import Select from "react-select";
import { centerOptions, doctorOptions, doctorsWithId } from "../contants/options";
import * as XLSX from 'xlsx';
import DoctorTables from "../tables/DoctorTables";
import ReferralTable from "../tables/ReferalTable";

const ReferalPayout = () => {
    const [filters, setFilters] = useState({
        centers: [],
        doctors: [],
        startDate: "",
        endDate: "",

    });

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    // Simulated API call
    const fetchData = async () => {
        setIsLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/doctor-referral-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                billingDoctorIds: filters?.doctors?.map((doctor) => doctor.value).length > 0 ? filters?.doctors?.map((doctor) => doctor.value) : null,
                locationIds: filters?.centers?.map((center) => center.value).length > 0 ? filters?.centers?.map((center) => center.value) : null,
                startDate: filters?.startDate,
                endDate: filters?.endDate
            })
        });

        const result = await response.json();
        setData(result);
        // setCurrentPage(1)
        setIsLoading(false);

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };


    const handleExport = () => {
        setIsLoading(true); // Show loading icon

        // Prepare data for export
        const exportData = data.map(item => ({
            "Referral Doctor Name": item['referred_by_doctor'],
            "Center": item['center'],
            "Primary Doctor": item['admitted_to_doctor'],
            "Patient Name": item['patient_name'],
            "Admitted On": new Date(item['admitted_at']).toLocaleDateString(),
            "Discharged On": new Date(item['discharged_at']).toLocaleDateString(),
            "Net Invoice Value": item['grand_total'].toFixed(2),
            "TPA": item['tpa'],
            "Paid": item['total_collected'].toFixed(2),
            "Unpaid": Math.max(0, (item['grand_total'] - item['total_collected'])).toFixed(2)
        }));

        // Construct the filename
        const startDate = filters.startDate ? new Date(filters.startDate).toLocaleDateString() : 'start';
        const endDate = filters.endDate ? new Date(filters.endDate).toLocaleDateString() : 'end';
        const locationNames = filters.centers?.map(center => center.label).join('_') || 'all_locations';
        const doctorNames = filters.doctors?.map(doctor => doctor.label).join('_') || 'all_doctors';
        const filename = `Referral_Doctors_${startDate}_to_${endDate}_${locationNames}_${doctorNames}.xlsx`;

        // Create a worksheet from the data
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Function to calculate column widths dynamically
        const getColumnWidths = (data) => {
            if (!data.length) return [];
            return Object.keys(data[0]).map((key) => ({
                wch: Math.max(
                    key.length, // Header length
                    ...data.map(row => (row[key] ? row[key].toString().length : 0)) // Max content length
                ) + 2 // Add padding
            }));
        };

        // Set auto-adjusting column widths
        ws['!cols'] = getColumnWidths(exportData);

        // Create a workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');

        // Write the workbook to a file
        XLSX.writeFile(wb, filename);

        setIsLoading(false); // Hide loading icon after export
    };




    return (
        <>
            <div style={{ padding: "20px" }}>
                <h2>Referal Doctor Info</h2>
                <div style={{ display: "flex", gap: "10px", marginBottom: "20px", justifyContent: "space-between" }}>
                    {/* Dropdown for Centers */}

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', width: "50%" }}>
                        {/* Multi-select for Centers */}
                        <Select
                            options={centerOptions}
                            isMulti
                            value={filters?.centers}
                            onChange={(selectedOptions) =>
                                setFilters((prev) => ({ ...prev, centers: selectedOptions }))
                            }
                            placeholder="All Centers"
                        />

                        {/* Multi-select for Doctors */}
                        <Select
                            options={doctorsWithId}
                            isMulti
                            value={filters?.doctors}
                            onChange={(selectedOptions) =>
                                setFilters((prev) => ({ ...prev, doctors: selectedOptions }))
                            }
                            placeholder="All Doctors"
                        />

                        {/* Start Date Picker */}
                        <label htmlFor="ed">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            placeholder="Start Date"
                            value={filters?.startDate}
                            onChange={handleInputChange}
                        />

                        {/* End Date Picker */}
                        <label htmlFor="ed">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            placeholder="End Date"
                            value={filters?.endDate}
                            onChange={handleInputChange}
                        />
                    </div>
                    {/* Search Button */}
                    <button
                        onClick={fetchData}
                        style={{
                            maxHeight: "50px",
                            backgroundColor: '#4CAF50', // Green background
                            color: 'white', // White text
                            padding: '10px 20px', // Padding
                            border: 'none', // Remove border
                            borderRadius: '5px', // Rounded corners
                            fontSize: '16px', // Font size
                            cursor: 'pointer', // Pointer cursor on hover
                            transition: 'background-color 0.3s ease', // Smooth transition for hover effect
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#45a049'} // Darker green on hover
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#4CAF50'} // Reset to original color
                    >
                        Search
                    </button>

                    <div style={{ gridColumn: 'span 2', textAlign: 'center' }}>
                        <button onClick={handleExport} disabled={isLoading}
                            style={{
                                maxHeight: "50px",
                                backgroundColor: 'blue', // Green background
                                color: 'white', // White text
                                padding: '10px 20px', // Padding
                                border: 'none', // Remove border
                                borderRadius: '5px', // Rounded corners
                                fontSize: '16px', // Font size
                                cursor: 'pointer', // Pointer cursor on hover
                                transition: 'background-color 0.3s ease', // Smooth transition for hover effect
                            }}>
                            {isLoading ? 'Exporting...' : 'Export to Excel'}
                        </button>
                        {isLoading && <span>Loading...</span>}
                    </div>
                </div>

                {/* Table for Displaying Data */}
                <ReferralTable
                    data={data}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    filters={filters}
                    flow={"surgerypackage"}
                />

            </div>
            <div className="totalpaymentparent">
                {filters.doctors.length === 1 && (
                    <div>
                        {/* Calculate the sum of the fields */}
                        <div className="total-payment">
                            <label className="head-label">Total Net Payable:</label>
                            <span>
                                {data.reduce((sum, item) => sum + parseFloat(item["Total Net Payable"] || 0), 0).toFixed(2)}
                            </span>
                        </div>
                        <div className="total-payment">
                            <label className="head-label">Paid:</label>
                            <span>
                                {data.reduce((sum, item) => sum + parseFloat(item["Paid"] || 0), 0).toFixed(2)}
                            </span>
                        </div>
                        <div className="total-payment">
                            <label className="head-label">Not Paid:</label>
                            <span>
                                {data.reduce((sum, item) => sum + parseFloat(item["Not Paid"] || 0), 0).toFixed(2)}
                            </span>
                        </div>
                    </div>
                )}
            </div>


        </>

    );
};

export default ReferalPayout;
